import { LegalPage } from "../components/site/LegalLayout";

const S = [
  { heading: "Acceptance of Terms", paragraphs: [
    "By accessing or using this website, you agree to be bound by these Terms of Service. If you do not agree, please do not use the website.",
  ]},
  { heading: "Use of the Website", paragraphs: [
    "This website provides public information about MST — Multiple Stream Team, including information about membership, the MST ecosystem, and the ability to submit a membership application or contact inquiry. You agree to use the website only for lawful purposes.",
  ]},
  { heading: "Eligibility", paragraphs: [
    "You must be at least 18 years of age (or the age of majority in your jurisdiction) to submit a membership application through this website.",
  ]},
  { heading: "Intellectual Property", paragraphs: [
    "The MST name, MST logo, website content, design, graphics, and other materials on this website are the property of Multiple Stream Team LLC or its licensors and are protected by applicable intellectual property laws. You may not copy, reproduce, distribute, or create derivative works without prior written permission.",
  ]},
  { heading: "Prohibited Conduct", paragraphs: [
    "You agree not to: submit false or misleading information; attempt to gain unauthorized access to any systems or data; interfere with the operation or security of the website; use automated tools to scrape or spam the website; or use the website in violation of any applicable law.",
  ]},
  { heading: "Accuracy of Information", paragraphs: [
    "You are responsible for the accuracy of the information you submit through this website, including membership applications and contact inquiries. MST may rely on the information you provide when evaluating applications.",
  ]},
  { heading: "Third-Party Services", paragraphs: [
    "The website may link to or integrate with third-party services. MST is not responsible for third-party services, their availability, or their terms and policies.",
  ]},
  { heading: "Private Member Platform (phpFox)", paragraphs: [
    "The private MST member network operates on a separate platform. Access to that platform is limited to approved members and is governed by separate terms, policies, and agreements presented within that platform. These Terms of Service apply only to this public website.",
  ]},
  { heading: "No Guarantee of Membership", paragraphs: [
    "MST is a private, invite-only organization. Submitting an application through this website does not create any right to membership and does not guarantee acceptance, an invitation, or any particular outcome.",
  ]},
  { heading: "Website Availability", paragraphs: [
    "We do not guarantee that the website will be available at all times or free from errors, interruptions, or defects. We may modify, suspend, or discontinue any part of the website at any time.",
  ]},
  { heading: "Disclaimers", paragraphs: [
    "The website and its content are provided on an \"as is\" and \"as available\" basis without warranties of any kind, whether express or implied. Content on this website is for general informational purposes only and does not constitute legal, financial, tax, or investment advice.",
  ]},
  { heading: "Limitation of Liability", paragraphs: [
    "To the maximum extent permitted by applicable law, Multiple Stream Team LLC and its leadership, members, and affiliates shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of this website. [ATTORNEY REVIEW REQUIRED — final limitation of liability provisions.]",
  ]},
  { heading: "Indemnification", paragraphs: [
    "You agree to indemnify and hold harmless Multiple Stream Team LLC from claims, damages, and expenses arising out of your misuse of the website or violation of these terms. [ATTORNEY REVIEW REQUIRED — final indemnification provisions.]",
  ]},
  { heading: "Changes to These Terms", paragraphs: [
    "We may update these Terms of Service from time to time. Updated terms will be posted on this page with a revised date. Continued use of the website after changes indicates acceptance.",
  ]},
  { heading: "Governing Law", paragraphs: [
    "These Terms of Service are governed by the laws of the State of Tennessee, without regard to conflict-of-law principles. [ATTORNEY REVIEW REQUIRED — venue, jurisdiction, and dispute-resolution provisions.]",
  ]},
  { heading: "Contact Information", paragraphs: [
    "Questions about these Terms of Service may be directed to Multiple Stream Team LLC at info@multiplestreamteam.com.",
  ]},
];

export default function Terms() {
  return (
    <LegalPage
      testId="terms-page"
      seo={{ title: "Terms of Service | MST — Multiple Stream Team", description: "Terms governing the use of the public MST website.", path: "/terms" }}
      label="Legal"
      title="Terms of Service"
      updated="June 2026"
      intro="These terms govern your use of the public MST website."
      sections={S}
    />
  );
}
